module.exports = __webpack_public_path__ + "static/media/kapidaode.7155d2d0.png";